import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'channelName',
      type: 'select',
      label: '渠道名称',
      clearable: true,
      filterable: true,
      placeholder: '请选择渠道名称'
    }
  ]
}
